import React from 'react';
import {connect} from "react-redux";
import {CABINET_LABELS, SIDEBAR_NAVIGATION_BUTTONS, SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import {FormattedMessage} from "react-intl";
import SqftOptionsCrown from "./toolCrown/SqftOptionsCrown";

const SqftNavigationCrownMolding = (props) => {
  const {activeFeature} = props;
  const {setSQFTActiveButton, setSQFTMenuOpened} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown

  const handleClose = () => {
    setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.move);
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
  }

  return (
    <div className={"content side-level2" + (expanded ? " expanded" : "")}>
      <div className="content-inner">
        <div className="summary-main-title">
          <div className="summary-main-text">
            <FormattedMessage id="sqft.navigation.submenu.crownTitle"/>
          </div>
          <button className="button--close"
                  onClick={handleClose}
          />
        </div>
        <div className="lightbox-scroll no-padding">
          <div className={"lightbox-options-wrapper"}>
            {
              <SqftOptionsCrown activeFeature={activeFeature}
                                partId={CABINET_LABELS.crown_molding}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationCrownMolding);
